export class Course {
  id: string;
  name: string;
}
